// @core/api/endpoints/legalentity/list_legal_entities.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListLegalEntitiesResponse,
} from '../../../types/legalentity';

const BASE_PATH = '/legalentity';

/**
 * List legal entities
 * Returns paginated list of legal entities visible to the requesting profile. Filterable by tenant, legal_form, status, country_code, search query (matches short_name/full_name/primary_tax_id).
 */
export async function ListLegalEntities(
  params?: {
    limit?: string | number | boolean;
    cursor?: string | number | boolean;
    direction?: string | number | boolean;
    sort?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListLegalEntitiesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/`;
  const requestOptions = options;
  return client.get<ListLegalEntitiesResponse>(requestPath, { ...requestOptions, params });
}
